import { useEffect } from "react";
import ambientMusic from "@/utils/AmbientMusic";

/**
 * useTabMusic — switches ambient music to the given mood while the calling
 * component is mounted. On unmount it does NOT stop the music: the parent
 * (GameView) re-asserts 'exploration' or 'battle' on its own next render,
 * which produces a smooth crossfade. iter 74.
 *
 * @param {string} mood
 * @param {object} [context] — extra hint for adaptive moods
 * @param {boolean} [enabled=true] — pass false to disable conditionally
 */
export default function useTabMusic(mood, context = null, enabled = true) {
  useEffect(() => {
    if (!enabled || !mood) return undefined;
    ambientMusic.play(mood, context);
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mood, enabled, JSON.stringify(context || null)]);
}
